<template>
  <div class="iframe-container">
    <iframe :src="iframeSrc" frameborder="0" allowfullscreen></iframe>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      iframeSrc: "",
    };
  },
  methods: {
    ...mapActions("sales_force", [
      "GetMasterParameter",
    ]),
    loadDataFrame() {
      this.GetMasterParameter({
        category: "frame_url_aoi",
      }).then((rsp) => {
        if (rsp != "No Data") {
          this.iframeSrc = rsp.data.payload[0].value;
        }
      });
    }
  },
  created() {
    if (this.$route.params.auth) {
      this.loadDataFrame()
    } else {
      this.$router.push({ name: "RegisAOIPage" });
    }
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.iframe-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
